import React, {useEffect, useState} from 'react';
import {useTheme} from "../../common/ProjectThemeProvider";
import {
    checkNullArr,
    checkNullJson,
    checkNullStr,
    createTimeout,
    deepObjectComparison,
    focusFormIdElement,
    getCurrUrlParamValue,
    getDefStr,
    getJsonValue,
    isBoolTrue,
    isJsonValueTrue,
    sanitizeMobileText
} from "../../common/fusion-ui/utils/ReactUtils";
import {sendAdminRequest} from "../utils/AdminUtils";
import {printError, printLog,} from "../../common/CommonUtils";
import {useToast} from "../../common/fusion-ui/provider/ToastProvider";
import {useNavigate} from "react-router-dom";
import {AdminModuleFieldsData, AdminModuleRouteUrls, AdminModules, AdminReqUrls, ShowViewType} from "../config/AdminConfig";
import {Avatar, GridBox, HorDiv, Section, Select, Switch} from "../../common/fusion-ui";
import {Constants, CssVariant, FsVarVariant, IconClass, Messages, Patterns} from "../../common/fusion-ui/config/FusionConfig";
import {AppTextEditor, ThemedIconButton, ThemedInput} from "../../common/components";
import {CscSelect, FormPageRoot, TimezoneSelect} from "../components";
import {AnimationType, EasingType, FramerAnimator} from "../../common/fusion-ui/animation/FramerAnimator";
import {useInternetStatus} from "../../common/fusion-ui/hook";
import {INPUT_FILE_MAX_SIZE, UnderMaintenance, UnderMaintenanceMsg} from "../../common/CommonConfig";

const Company__AddEditFormPage = React.memo(({
                                                 updateOnly,
                                                 open,
                                                 onHide,
                                                 recordId,
                                                 showAs = ShowViewType.PAGE,
                                                 onSuccess,
                                             }) => {
    const TAG = "Company__AddEditFormPage";

    const moduleName = AdminModules.Company;
    const mf = AdminModuleFieldsData[moduleName];

    const theme = useTheme();
    const navigate = useNavigate();
    const {showToast, changeToastVariant} = useToast();
    const {isOnline, internetCheckingMsg} = useInternetStatus();
    // const {isScreenXs, isScreenSm, isScreenMd, isScreenResizing} = useScreenSize();

    const animator = new FramerAnimator();

    const FOCUS_DELAY = 2000;
    const SECTIONS = {
        companyAndProject: "Company & Project Details",
        clientContacts: "Client Contacts",
        modulesAndPrvlgs: "Modules & Privileges",
        welcomeAndVarious: "Welcome Message & Other Pages",
    };

    const Fields = {
        updateRecordId: 'updateRecordId',

        isUpdateFormDataFetched: 'isUpdateFormDataFetched',

        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',

        submitBtn_AsLoading: 'submitBtn_AsLoading',
        submitBtn_disabled: 'submitBtn_disabled',

        parentComps: 'parentComps',
        showParentCompsLoading: 'showParentCompsLoading',
        isParentCompsFetched: 'isParentCompsFetched',
        isLogoFileLoading: 'isLogoFileLoading',

        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',
    };
    const [fieldsData, setFieldsData] = useState({});
    // const [formData, setFormData] = useState(Company__AddEditFormPage_FormData);
    const [formData, setFormData] = useState({});
    const [formFieldsMsgs, setFormFieldsMsgs] = useState({});
    const [sectionsExpanded, setSectionsExpanded] = useState({
        [SECTIONS.companyAndProject]: true,
        // [SECTIONS.clientContacts]: false,
        // [SECTIONS.modulesAndPrvlgs]: false,
        // [SECTIONS.welcomeAndVarious]: false,
    });
    const SectionRequiredFields = {
        [SECTIONS.companyAndProject]: [mf.parentCompanyId, mf.companyName, mf.email, mf.phone, mf.address, mf.countryId, mf.timezoneId, mf.managerName, mf.managerEmail, mf.managerPhone, mf.projectName, mf.subdomain, mf.domainUrl, mf.remark, mf.getHelp, mf.logo,],
        [SECTIONS.clientContacts]: [mf.contactPersonName1, mf.contactPersonDesignation1, mf.contactPersonPhone1, mf.contactPersonMobile1, mf.contactPersonEmail1, mf.contactPersonName2, mf.contactPersonDesignation2, mf.contactPersonPhone2, mf.contactPersonMobile2, mf.contactPersonEmail2, mf.contactPersonName3, mf.contactPersonDesignation3, mf.contactPersonPhone3, mf.contactPersonMobile3, mf.contactPersonEmail3,],
        [SECTIONS.modulesAndPrvlgs]: [],
        [SECTIONS.welcomeAndVarious]: [],
    };

    useEffect(() => {
        if (!checkNullStr(getField(Fields.panelMsg)) && !isUpdateMode()) {
            updateField(Fields.isDataLoading, false);
            updateField(Fields.isDataFound, true);
        }

        log('useEffect.showAs:', showAs, 'recordId:', recordId);
        if (showAs == ShowViewType.PAGE) {
            if (isUpdateMode()) {
                const id = getCurrUrlParamValue('id');
                log('useEffect.showAs:', showAs, 'id:', id);
                fetchEditModeData(id);
            }
        } else {
            if (checkNullStr(recordId) && isUpdateMode()) {
                fetchEditModeData(recordId, false);
            }
        }
        fetchParentCompanies();
    }, [recordId, showAs, updateOnly]);

    return (<>
            <FormPageRoot
                tag={TAG}
                moduleName={moduleName}
                updateOnly={isUpdateMode()}
                isDataLoading={getField(Fields.isDataLoading)}
                isDataFound={getField(Fields.isDataFound)}
                dataLoadingMsg={getField(Fields.dataLoadingMsg)}
                open={open}
                onHide={() => {
                    if (onHide) onHide();
                    clearPanelData();
                }}
                showAs={showAs}
                md={12}
                drawerWidth={'75%'}
                panelMsg={getField(Fields.panelMsg)}
                panelMsgColor={getField(Fields.panelMsgColor)}
                isSubmitDisabled={isFieldTrue(Fields.submitBtn_disabled)}
                isSubmitLoading={isFieldTrue(Fields.submitBtn_AsLoading)}
                onSubmit={handleSubmit}
            >
                <div className={''}>
                    {/*company & project section*/}
                    <ExpandableView title={SECTIONS.companyAndProject}
                                    retainInDOM={true}
                                    expanded={sectionsExpanded[SECTIONS.companyAndProject]}
                                    onToggle={(exp) => handleSectionExpCollapse(SECTIONS.companyAndProject, exp)}>
                        <GridBox className={'px-0'} sm={12} md={6} justifyAt={'start'}>
                            {/*company-details*/}
                            <Section
                                className={`px-3 py-2 h-100 app-section hover`}
                                titleClassName={'fs-md px-1'}
                                title={"Company Details"}
                                borderColor={theme.text10}
                                titleColor={theme.text}
                                titleAt={'start'}
                                overflow={'visible'}
                                roundedVariant={4}>
                                {animator.setAnimationType(AnimationType.SLIDE_RIGHT).setDuration(200).setEasing(EasingType.EASE_IN).renderChildren(
                                    <div>
                                        {/*parentCompanyName-select*/}
                                        <Select
                                            id={mf.parentCompanyId.column}
                                            wrapperClassName={`w-100 mt-2`}
                                            className={`w-100 rounded-3 py-2`}
                                            innerWrapperClassName={'w-100'}
                                            labelClassName={'w-100 text-input-label'}
                                            variant={'primary'}
                                            justifyAt={'center'}
                                            // style={{height: '32px'}}
                                            labelColor={theme.text40}
                                            label={'Select a parent company'}
                                            placeholder={'Select a parent company'}
                                            wrap={'wrap'}
                                            textKey={'text'}
                                            idKey={'id'}
                                            required={true}
                                            options={getField(Fields.parentComps, [])}
                                            defOption={getFormField(mf.parentCompanyId)}
                                            showLoader={isFieldTrue(Fields.showParentCompsLoading)}
                                            showRefresh={true}
                                            onRefresh={() => fetchParentCompanies(false)}
                                            onChange={(e, text, value) => {
                                                // log('parentComp.Select.onChange::text:', text, "value:", value);
                                                updateFormField(mf.parentCompanyId, value);
                                                updateFormField(mf.parentCompanyName, text);
                                            }}
                                        />

                                        {/*companyName*/}
                                        <ThemedInput
                                            wrapperClassName={'mt-3'}
                                            className={''}
                                            label={mf.companyName.title}
                                            placeholder={mf.companyName.title}
                                            id={mf.companyName.column}
                                            value={getFormField(mf.companyName)}
                                            msg={getFormFieldMsg(mf.companyName)}
                                            required={true}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                updateFormField(mf.companyName, value);
                                                updateFormFieldMsg(mf.companyName, '');
                                                panelLog('');
                                            }}
                                        />

                                        {/*email*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            label={mf.email.title}
                                            placeholder={mf.email.title}
                                            id={mf.email.column}
                                            value={getFormField(mf.email)}
                                            msg={getFormFieldMsg(mf.email)}
                                            required={true}
                                            type={'email'}
                                            onChange={(e) => {
                                                const value = e.target.value + '';
                                                if (value.length <= 100) {
                                                    if (checkNullStr(value)) {
                                                        let valid = Patterns.emailStandard.test(value);
                                                        updateFormField(mf.email, value);
                                                        if (checkNullStr(value)) updateFormFieldMsg(mf.email, valid ? '' : 'Invalid email!');
                                                    }
                                                }
                                                panelLog('');
                                            }}
                                        />

                                        {/*phone*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            type={'mobile'}
                                            label={mf.phone.title}
                                            placeholder={mf.phone.title}
                                            id={mf.phone.column}
                                            value={getFormField(mf.phone)}
                                            msg={getFormFieldMsg(mf.phone)}
                                            required={true}
                                            onChange={(e) => {
                                                const value = e.target.value + '';
                                                if (value.length <= 14) {
                                                    updateFormField(mf.phone, sanitizeMobileText(value, 14));
                                                    if (checkNullStr(value)) updateFormFieldMsg(mf.phone, '');
                                                }
                                                panelLog('');
                                            }}
                                        />

                                        {/*website*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            label={mf.website.title}
                                            placeholder={mf.website.title}
                                            id={mf.website.column}
                                            value={getFormField(mf.website)}
                                            msg={getFormFieldMsg(mf.website)}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                updateFormField(mf.website, value);
                                                updateFormFieldMsg(mf.website, '');
                                                panelLog('');
                                            }}
                                        />

                                        {/*address*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            label={mf.address.title}
                                            placeholder={mf.address.title}
                                            id={mf.address.column}
                                            value={getFormField(mf.address)}
                                            msg={getFormFieldMsg(mf.address)}
                                            required={true}
                                            asTextArea={true}
                                            style={{minHeight: '60px', height: '80px', maxHeight: '160px'}}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                updateFormField(mf.address, value);
                                                updateFormFieldMsg(mf.address, '');
                                                panelLog('');
                                            }}
                                        />

                                        {/*csc-select*/}
                                        <CscSelect
                                            wrapperClassName={''}
                                            className={''}
                                            requiredCountry={true}
                                            fetchDefData={true}
                                            defCountryId={getFormField(mf.countryId)}
                                            defStateId={getFormField(mf.stateId)}
                                            defCityId={getFormField(mf.cityId)}
                                            onCountryUpdate={(id, name, data) => {
                                                // log('onCountryUpdate.name:', name, 'id:', id);
                                                updateFormField(mf.countryName, name);
                                                updateFormField(mf.countryId, id);
                                                panelLog('');
                                            }}
                                            onStateUpdate={(id, name, data) => {
                                                // log('onStateUpdate.name:', name, 'id:', id);
                                                updateFormField(mf.stateName, name);
                                                updateFormField(mf.stateId, id);
                                                panelLog('');
                                            }}
                                            onCityUpdate={(id, name, data) => {
                                                // log('onCityUpdate.name:', name, 'id:', id);
                                                updateFormField(mf.cityName, name);
                                                updateFormField(mf.cityId, id);
                                                panelLog('');
                                            }}
                                        />

                                        <HorDiv className={'mb-2'} variant={theme.text70}/>

                                        {/*timezone-select*/}
                                        <TimezoneSelect
                                            wrapperClassName={''}
                                            className={''}
                                            required={true}
                                            defTsId={getFormField(mf.timezoneId)}
                                            onChange={(name, id) => {
                                                // log('ts.onChange.name:', name, 'id:', id);
                                                updateFormField(mf.timezoneName, name);
                                                updateFormField(mf.timezoneId, id);
                                                panelLog('');
                                            }}
                                        />
                                    </div>)}
                            </Section>

                            {/*project-details*/}
                            <Section
                                className={`px-3 py-2 h-100 app-section hover`}
                                titleClassName={'fs-md px-1'}
                                title={"Project Details"}
                                borderColor={theme.text10}
                                titleColor={theme.text}
                                titleAt={'start'}
                                overflow={'visible'}
                                roundedVariant={4}>
                                {animator.setAnimationType(AnimationType.SLIDE_RIGHT).setDuration(200).setEasing(EasingType.EASE_IN).renderChildren(
                                    <div>
                                        {/*managerName*/}
                                        <ThemedInput
                                            wrapperClassName={'mt-2'}
                                            className={''}
                                            label={mf.managerName.titleAlt}
                                            placeholder={mf.managerName.titleAlt}
                                            id={mf.managerName.column}
                                            value={getFormField(mf.managerName)}
                                            msg={getFormFieldMsg(mf.managerName)}
                                            required={true}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                updateFormField(mf.managerName, value);
                                                updateFormFieldMsg(mf.managerName, '');
                                                panelLog('');
                                            }}
                                        />

                                        {/*managerEmail*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            label={mf.managerEmail.titleAlt}
                                            placeholder={mf.managerEmail.titleAlt}
                                            id={mf.managerEmail.column}
                                            value={getFormField(mf.managerEmail)}
                                            msg={getFormFieldMsg(mf.managerEmail)}
                                            required={true}
                                            iMsg={<p className={'text-wrap m-0 p-0'}>
                                                {`This ID will be used for sending notification emails to VoK users, in case of Content Upload and New Event creation. Do NOT provide email ID with domain KOLsAndPeers.com`}
                                            </p>}
                                            type={'email'}
                                            onChange={(e) => {
                                                const value = e.target.value + '';
                                                if (value.length <= 100) {
                                                    if (checkNullStr(value)) {
                                                        let valid = Patterns.emailStandard.test(value);
                                                        updateFormField(mf.managerEmail, value);
                                                        if (checkNullStr(value)) updateFormFieldMsg(mf.managerEmail, valid ? '' : 'Invalid email!');
                                                    }
                                                }
                                                panelLog('');
                                            }}
                                        />

                                        {/*managerPhone*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            label={mf.managerPhone.title}
                                            placeholder={mf.managerPhone.title}
                                            id={mf.managerPhone.column}
                                            value={getFormField(mf.managerPhone)}
                                            msg={getFormFieldMsg(mf.managerPhone)}
                                            type={'mobile'}
                                            required={true}
                                            onChange={(e) => {
                                                const value = e.target.value + '';
                                                if (value.length <= 14) {
                                                    updateFormField(mf.managerPhone, sanitizeMobileText(value, 14));
                                                    if (checkNullStr(value)) updateFormFieldMsg(mf.managerPhone, '');
                                                }
                                                panelLog('');
                                            }}
                                        />

                                        <HorDiv className={'mb-2'} variant={theme.text70}/>

                                        {/*projectName*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            label={mf.projectName.title}
                                            placeholder={mf.projectName.title}
                                            id={mf.projectName.column}
                                            value={getFormField(mf.projectName)}
                                            msg={getFormFieldMsg(mf.projectName)}
                                            required={true}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                updateFormField(mf.projectName, value);
                                                updateFormFieldMsg(mf.projectName, '');
                                                panelLog('');
                                            }}
                                        />

                                        {/*subdomain*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            label={mf.subdomain.titleAlt}
                                            placeholder={mf.subdomain.titleAlt}
                                            id={mf.subdomain.column}
                                            value={getFormField(mf.subdomain)}
                                            msg={getFormFieldMsg(mf.subdomain)}
                                            required={true}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                updateFormField(mf.subdomain, value);
                                                updateFormFieldMsg(mf.subdomain, '');
                                                panelLog('');
                                            }}
                                        />

                                        {/*subdomainAccess*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            label={mf.subdomainAccess.title}
                                            placeholder={mf.subdomainAccess.title}
                                            id={mf.subdomainAccess.column}
                                            value={getFormField(mf.subdomainAccess)}
                                            msg={getFormFieldMsg(mf.subdomainAccess)}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                updateFormField(mf.subdomainAccess, value);
                                                updateFormFieldMsg(mf.subdomainAccess, '');
                                                panelLog('');
                                            }}
                                        />

                                        {/*domainUrl*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            label={mf.domainUrl.title}
                                            placeholder={mf.domainUrl.title}
                                            id={mf.domainUrl.column}
                                            value={getFormField(mf.domainUrl)}
                                            msg={getFormFieldMsg(mf.domainUrl)}
                                            required={true}
                                            iMsg={`Domain-url for this company. It will be used for redirecting the user when login is successful.`}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                updateFormField(mf.domainUrl, value);
                                                updateFormFieldMsg(mf.domainUrl, '');
                                                panelLog('');
                                            }}
                                        />

                                        <HorDiv className={'mb-2'} variant={theme.text70}/>

                                        {/*remark*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            label={mf.remark.title}
                                            placeholder={mf.remark.title}
                                            id={mf.remark.column}
                                            value={getFormField(mf.remark)}
                                            msg={getFormFieldMsg(mf.remark)}
                                            required={true}
                                            asTextArea={true}
                                            style={{minHeight: '60px', height: '80px', maxHeight: '160px'}}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                updateFormField(mf.remark, value);
                                                updateFormFieldMsg(mf.remark, '');
                                                panelLog('');
                                            }}
                                        />

                                        {/*getHelp*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            label={mf.getHelp.title}
                                            placeholder={mf.getHelp.title}
                                            id={mf.getHelp.column}
                                            value={getFormField(mf.getHelp)}
                                            msg={getFormFieldMsg(mf.getHelp)}
                                            required={true}
                                            asTextArea={true}
                                            style={{minHeight: '60px', height: '80px', maxHeight: '160px'}}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                updateFormField(mf.getHelp, value);
                                                updateFormFieldMsg(mf.getHelp, '');
                                                panelLog('');
                                            }}
                                        />

                                        <HorDiv className={'mb-2'} variant={theme.text70}/>

                                        {/*images*/}
                                        <GridBox className={'px-2'} sm={12} md={4} justifyAt={'start'}>
                                            {/*logo*/}
                                            <Avatar
                                                wrapperClassName={''}
                                                className={''}
                                                labelClassName={'w-100x pb-2 text-startxx'}
                                                justifyAt={'center'}
                                                alignAt={'start'}
                                                wrap={'wrap'}
                                                direction={'column'}
                                                label={mf.logo.titleAlt}
                                                labelColor={theme.text40}
                                                accept={'.jpg, .jpeg, .png'}
                                                editTooltip={`Edit (.jpg, .jpeg, .png)`}
                                                showEdit={true}
                                                showDelete={true}
                                                circular={false}
                                                required={true}
                                                showFullPreviewDialog={true}
                                                defAvatarImg={Constants.imgVector}
                                                editSize={'21px'}
                                                size={'110px'}
                                                maxSize={INPUT_FILE_MAX_SIZE}
                                                onChange={(e, file, path, name, ext) => {
                                                    log('Avatar.logo.onChange.name:', name, 'ext:', ext);
                                                    updateFormField(mf.logo, file);
                                                    updateFormField(mf.logoExt, ext);
                                                }}
                                                onDeleteClick={() => {
                                                    updateFormField(mf.logo, null);
                                                    updateFormField(mf.logoExt, null);
                                                }}
                                                onInvalidFormat={(e, name) => {
                                                    toast(`Invalid file format. File must be jpg, jpeg or png`, CssVariant.danger);
                                                }}
                                                onSizeExceeded={() => {
                                                    toast(`Max size exceeded: ${INPUT_FILE_MAX_SIZE}`, CssVariant.danger);
                                                }}>
                                                {getFormField(mf.logo)}
                                            </Avatar>

                                            {/*brandLogo*/}
                                            <Avatar
                                                wrapperClassName={'mt-3x'}
                                                className={''}
                                                labelClassName={'w-100x pb-2 text-startxx'}
                                                justifyAt={'center'}
                                                alignAt={'start'}
                                                wrap={'wrap'}
                                                direction={'column'}
                                                label={mf.brandLogo.title}
                                                labelColor={theme.text40}
                                                accept={'.jpg, .jpeg, .png'}
                                                editTooltip={`Edit (jpg, .jpeg, .png)`}
                                                showEdit={true}
                                                showDelete={true}
                                                circular={false}
                                                showFullPreviewDialog={true}
                                                defAvatarImg={Constants.imgVector}
                                                editSize={'21px'}
                                                size={'110px'}
                                                maxSize={INPUT_FILE_MAX_SIZE}
                                                onChange={(e, file, path, name, ext) => {
                                                    log('Avatar.brandLogo.onChange.name:', name, 'ext:', ext);
                                                    updateFormField(mf.brandLogo, file);
                                                    updateFormField(mf.brandLogoExt, ext);
                                                }}
                                                onDeleteClick={() => {
                                                    updateFormField(mf.brandLogo, null);
                                                    updateFormField(mf.brandLogoExt, null);
                                                }}
                                                onInvalidFormat={(e, name) => {
                                                    toast(`Invalid file format. File must be jpg, jpeg or png`, CssVariant.danger);
                                                }}
                                                onSizeExceeded={() => {
                                                    toast(`Max size exceeded: ${INPUT_FILE_MAX_SIZE}`, CssVariant.danger);
                                                }}>
                                                {getFormField(mf.brandLogo)}
                                            </Avatar>

                                            {/*footerLogo*/}
                                            <Avatar
                                                wrapperClassName={'mt-3x'}
                                                className={''}
                                                labelClassName={'w-100x pb-2 text-startxx'}
                                                justifyAt={'center'}
                                                alignAt={'start'}
                                                wrap={'wrap'}
                                                direction={'column'}
                                                label={mf.footerLogo.title}
                                                labelColor={theme.text40}
                                                accept={'.jpg, .jpeg, .png'}
                                                editTooltip={`Edit (.jpg, .jpeg, .png)`}
                                                showEdit={true}
                                                showDelete={true}
                                                circular={false}
                                                showFullPreviewDialog={true}
                                                defAvatarImg={Constants.imgVector}
                                                editSize={'21px'}
                                                size={'110px'}
                                                maxSize={INPUT_FILE_MAX_SIZE}
                                                onChange={(e, file, path, name, ext) => {
                                                    log('Avatar.footerLogo.onChange.name:', name, 'ext:', ext);
                                                    updateFormField(mf.footerLogo, file);
                                                    updateFormField(mf.footerLogoExt, ext);
                                                }}
                                                onDeleteClick={() => {
                                                    updateFormField(mf.footerLogo, null);
                                                    updateFormField(mf.footerLogoExt, null);
                                                }}
                                                onInvalidFormat={(e, name) => {
                                                    toast(`Invalid file format. File must be jpg, jpeg or png`, CssVariant.danger);
                                                }}
                                                onSizeExceeded={() => {
                                                    toast(`Max size exceeded: ${INPUT_FILE_MAX_SIZE}`, CssVariant.danger);
                                                }}>
                                                {getFormField(mf.footerLogo)}
                                            </Avatar>
                                        </GridBox>
                                    </div>)}
                            </Section>
                        </GridBox>
                    </ExpandableView>

                    {/*client-contact section*/}
                    <ExpandableView className={'mt-3'} title={SECTIONS.clientContacts}
                                    retainInDOM={false}
                                    expanded={sectionsExpanded[SECTIONS.clientContacts]}
                                    onToggle={(exp) => handleSectionExpCollapse(SECTIONS.clientContacts, exp)}>
                        <GridBox className={'px-0'} sm={12} md={4} justifyAt={'start'}>
                            {/*contact-person-1*/}
                            <Section
                                className={`px-3 py-2 h-100 app-section hover`}
                                titleClassName={'fs-md px-1'}
                                title={"Contact Person 1 (Key Contact)"}
                                borderColor={theme.text10}
                                titleColor={theme.text}
                                titleAt={'start'}
                                roundedVariant={4}>
                                {animator.setAnimationType(AnimationType.SLIDE_RIGHT).setDuration(200).setEasing(EasingType.EASE_IN).renderChildren(
                                    <div>
                                        {/*contactPersonName1*/}
                                        <ThemedInput
                                            wrapperClassName={'mt-2'}
                                            className={''}
                                            label={mf.contactPersonName1.titleAlt}
                                            placeholder={mf.contactPersonName1.titleAlt}
                                            id={mf.contactPersonName1.column}
                                            value={getFormField(mf.contactPersonName1)}
                                            msg={getFormFieldMsg(mf.contactPersonName1)}
                                            required={true}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                updateFormField(mf.contactPersonName1, value);
                                                updateFormFieldMsg(mf.contactPersonName1, '');
                                                panelLog('');
                                            }}
                                        />

                                        {/*contactPersonDesignation1*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            label={mf.contactPersonDesignation1.title}
                                            placeholder={mf.contactPersonDesignation1.title}
                                            id={mf.contactPersonDesignation1.column}
                                            value={getFormField(mf.contactPersonDesignation1)}
                                            msg={getFormFieldMsg(mf.contactPersonDesignation1)}
                                            required={true}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                updateFormField(mf.contactPersonDesignation1, value);
                                                updateFormFieldMsg(mf.contactPersonDesignation1, '');
                                                panelLog('');
                                            }}
                                        />

                                        {/*contactPersonPhone1*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            label={mf.contactPersonPhone1.title}
                                            placeholder={mf.contactPersonPhone1.title}
                                            id={mf.contactPersonPhone1.column}
                                            value={getFormField(mf.contactPersonPhone1)}
                                            msg={getFormFieldMsg(mf.contactPersonPhone1)}
                                            required={true}
                                            type={'mobile'}
                                            onChange={(e) => {
                                                const value = e.target.value + '';
                                                if (value.length <= 14) {
                                                    updateFormField(mf.contactPersonPhone1, sanitizeMobileText(value, 14));
                                                    if (checkNullStr(value)) updateFormFieldMsg(mf.contactPersonPhone1, '');
                                                }
                                                panelLog('');
                                            }}
                                        />

                                        {/*contactPersonMobile1*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            label={mf.contactPersonMobile1.title}
                                            placeholder={mf.contactPersonMobile1.title}
                                            id={mf.contactPersonMobile1.column}
                                            value={getFormField(mf.contactPersonMobile1)}
                                            msg={getFormFieldMsg(mf.contactPersonMobile1)}
                                            required={true}
                                            type={'mobile'}
                                            onChange={(e) => {
                                                const value = e.target.value + '';
                                                if (value.length <= 14) {
                                                    updateFormField(mf.contactPersonMobile1, sanitizeMobileText(value, 14));
                                                    if (checkNullStr(value)) updateFormFieldMsg(mf.contactPersonMobile1, '');
                                                }
                                                panelLog('');
                                            }}
                                        />

                                        {/*contactPersonEmail1*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            label={mf.contactPersonEmail1.title}
                                            placeholder={mf.contactPersonEmail1.title}
                                            id={mf.contactPersonEmail1.column}
                                            value={getFormField(mf.contactPersonEmail1)}
                                            msg={getFormFieldMsg(mf.contactPersonEmail1)}
                                            required={true}
                                            type={'email'}
                                            onChange={(e) => {
                                                const value = e.target.value + '';
                                                if (value.length <= 100) {
                                                    if (checkNullStr(value)) {
                                                        let valid = Patterns.emailStandard.test(value);
                                                        updateFormField(mf.contactPersonEmail1, value);
                                                        if (checkNullStr(value)) updateFormFieldMsg(mf.contactPersonEmail1, valid ? '' : 'Invalid email!');
                                                    }
                                                }
                                                panelLog('');
                                            }}
                                        />
                                    </div>)}
                            </Section>

                            {/*contact-person-2*/}
                            <Section
                                className={`px-3 py-2 h-100 app-section hover`}
                                titleClassName={'fs-md px-1'}
                                title={"Contact Person 2 (Medical Contact)"}
                                borderColor={theme.text10}
                                titleColor={theme.text}
                                titleAt={'start'}
                                roundedVariant={4}>
                                {animator.setAnimationType(AnimationType.SLIDE_RIGHT).setDuration(200).setEasing(EasingType.EASE_IN).renderChildren(
                                    <div>
                                        {/*contactPersonName2*/}
                                        <ThemedInput
                                            wrapperClassName={'mt-2'}
                                            className={''}
                                            label={mf.contactPersonName2.title}
                                            placeholder={mf.contactPersonName2.title}
                                            id={mf.contactPersonName2.column}
                                            value={getFormField(mf.contactPersonName2)}
                                            msg={getFormFieldMsg(mf.contactPersonName2)}
                                            required={true}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                updateFormField(mf.contactPersonName2, value);
                                                updateFormFieldMsg(mf.contactPersonName2, '');
                                                panelLog('');
                                            }}
                                        />

                                        {/*contactPersonDesignation2*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            label={mf.contactPersonDesignation2.title}
                                            placeholder={mf.contactPersonDesignation2.title}
                                            id={mf.contactPersonDesignation2.column}
                                            value={getFormField(mf.contactPersonDesignation2)}
                                            msg={getFormFieldMsg(mf.contactPersonDesignation2)}
                                            required={true}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                updateFormField(mf.contactPersonDesignation2, value);
                                                updateFormFieldMsg(mf.contactPersonDesignation2, '');
                                                panelLog('');
                                            }}
                                        />

                                        {/*contactPersonPhone2*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            label={mf.contactPersonPhone2.title}
                                            placeholder={mf.contactPersonPhone2.title}
                                            id={mf.contactPersonPhone2.column}
                                            value={getFormField(mf.contactPersonPhone2)}
                                            msg={getFormFieldMsg(mf.contactPersonPhone2)}
                                            required={true}
                                            type={'mobile'}
                                            onChange={(e) => {
                                                const value = e.target.value + '';
                                                if (value.length <= 14) {
                                                    updateFormField(mf.contactPersonPhone2, sanitizeMobileText(value, 14));
                                                    if (checkNullStr(value)) updateFormFieldMsg(mf.contactPersonPhone2, '');
                                                }
                                                panelLog('');
                                            }}
                                        />

                                        {/*contactPersonMobile2*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            label={mf.contactPersonMobile2.title}
                                            placeholder={mf.contactPersonMobile2.title}
                                            id={mf.contactPersonMobile2.column}
                                            value={getFormField(mf.contactPersonMobile2)}
                                            msg={getFormFieldMsg(mf.contactPersonMobile2)}
                                            required={true}
                                            type={'mobile'}
                                            onChange={(e) => {
                                                const value = e.target.value + '';
                                                if (value.length <= 14) {
                                                    updateFormField(mf.contactPersonMobile2, sanitizeMobileText(value, 14));
                                                    if (checkNullStr(value)) updateFormFieldMsg(mf.contactPersonMobile2, '');
                                                }
                                                panelLog('');
                                            }}
                                        />

                                        {/*contactPersonEmail2*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            label={mf.contactPersonEmail2.title}
                                            placeholder={mf.contactPersonEmail2.title}
                                            id={mf.contactPersonEmail2.column}
                                            value={getFormField(mf.contactPersonEmail2)}
                                            msg={getFormFieldMsg(mf.contactPersonEmail2)}
                                            required={true}
                                            type={'email'}
                                            onChange={(e) => {
                                                const value = e.target.value + '';
                                                if (value.length <= 100) {
                                                    if (checkNullStr(value)) {
                                                        let valid = Patterns.emailStandard.test(value);
                                                        updateFormField(mf.contactPersonEmail2, value);
                                                        if (checkNullStr(value)) updateFormFieldMsg(mf.contactPersonEmail2, valid ? '' : 'Invalid email!');
                                                    }
                                                }
                                                panelLog('');
                                            }}
                                        />
                                    </div>)}
                            </Section>

                            {/*contact-person-3*/}
                            <Section
                                className={`px-3 py-2 h-100 app-section hover`}
                                titleClassName={'fs-md px-1'}
                                title={"Contact Person 3 (Will show in the footer & help page)"}
                                borderColor={theme.text10}
                                titleColor={theme.text}
                                titleAt={'start'}
                                roundedVariant={4}>
                                {animator.setAnimationType(AnimationType.SLIDE_RIGHT).setDuration(200).setEasing(EasingType.EASE_IN).renderChildren(
                                    <div>
                                        {/*contactPersonName3*/}
                                        <ThemedInput
                                            wrapperClassName={'mt-2'}
                                            className={''}
                                            label={mf.contactPersonName3.title}
                                            placeholder={mf.contactPersonName3.title}
                                            id={mf.contactPersonName3.column}
                                            value={getFormField(mf.contactPersonName3)}
                                            msg={getFormFieldMsg(mf.contactPersonName3)}
                                            required={true}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                updateFormField(mf.contactPersonName3, value);
                                                updateFormFieldMsg(mf.contactPersonName3, '');
                                                panelLog('');
                                            }}
                                        />

                                        {/*contactPersonDesignation3*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            label={mf.contactPersonDesignation3.title}
                                            placeholder={mf.contactPersonDesignation3.title}
                                            id={mf.contactPersonDesignation3.column}
                                            value={getFormField(mf.contactPersonDesignation3)}
                                            msg={getFormFieldMsg(mf.contactPersonDesignation3)}
                                            required={true}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                updateFormField(mf.contactPersonDesignation3, value);
                                                updateFormFieldMsg(mf.contactPersonDesignation3, '');
                                                panelLog('');
                                            }}
                                        />

                                        {/*contactPersonPhone3*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            label={mf.contactPersonPhone3.title}
                                            placeholder={mf.contactPersonPhone3.title}
                                            id={mf.contactPersonPhone3.column}
                                            value={getFormField(mf.contactPersonPhone3)}
                                            msg={getFormFieldMsg(mf.contactPersonPhone3)}
                                            required={true}
                                            type={'mobile'}
                                            onChange={(e) => {
                                                const value = e.target.value + '';
                                                if (value.length <= 14) {
                                                    updateFormField(mf.contactPersonPhone3, sanitizeMobileText(value, 14));
                                                    if (checkNullStr(value)) updateFormFieldMsg(mf.contactPersonPhone3, '');
                                                }
                                                panelLog('');
                                            }}
                                        />

                                        {/*contactPersonMobile3*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            label={mf.contactPersonMobile3.title}
                                            placeholder={mf.contactPersonMobile3.title}
                                            id={mf.contactPersonMobile3.column}
                                            value={getFormField(mf.contactPersonMobile3)}
                                            msg={getFormFieldMsg(mf.contactPersonMobile3)}
                                            required={true}
                                            type={'mobile'}
                                            onChange={(e) => {
                                                const value = e.target.value + '';
                                                if (value.length <= 14) {
                                                    updateFormField(mf.contactPersonMobile3, sanitizeMobileText(value, 14));
                                                    if (checkNullStr(value)) updateFormFieldMsg(mf.contactPersonMobile3, '');
                                                }
                                                panelLog('');
                                            }}
                                        />

                                        {/*contactPersonEmail3*/}
                                        <ThemedInput
                                            wrapperClassName={''}
                                            className={''}
                                            label={mf.contactPersonEmail3.title}
                                            placeholder={mf.contactPersonEmail3.title}
                                            id={mf.contactPersonEmail3.column}
                                            value={getFormField(mf.contactPersonEmail3)}
                                            msg={getFormFieldMsg(mf.contactPersonEmail3)}
                                            required={true}
                                            type={'email'}
                                            onChange={(e) => {
                                                const value = e.target.value + '';
                                                if (value.length <= 100) {
                                                    if (checkNullStr(value)) {
                                                        let valid = Patterns.emailStandard.test(value);
                                                        updateFormField(mf.contactPersonEmail3, value);
                                                        if (checkNullStr(value)) updateFormFieldMsg(mf.contactPersonEmail3, valid ? '' : 'Invalid email!');
                                                    }
                                                }
                                                panelLog('');
                                            }}
                                        />
                                    </div>)}
                            </Section>
                        </GridBox>
                    </ExpandableView>

                    {/*modules & prvlgs section*/}
                    <ExpandableView className={'mt-3'} title={SECTIONS.modulesAndPrvlgs}
                                    retainInDOM={false}
                                    expanded={sectionsExpanded[SECTIONS.modulesAndPrvlgs]}
                                    onToggle={(exp) => handleSectionExpCollapse(SECTIONS.modulesAndPrvlgs, exp)}>
                        <GridBox className={'px-0'} sm={12} md={6} justifyAt={'start'}>
                            {/*access-modules*/}
                            <Section
                                className={`px-3 py-2 h-100 app-section hover`}
                                titleClassName={'fs-md px-1'}
                                title={"Access Modules (Select to add to member area)"}
                                borderColor={theme.text10}
                                titleColor={theme.text}
                                titleAt={'start'}
                                roundedVariant={4}>
                                {animator.setAnimationType(AnimationType.SLIDE_RIGHT).setDuration(200).setEasing(EasingType.EASE_IN).renderChildren(
                                    <div>
                                        {[mf.contentPeers,
                                            mf.contentMedical,
                                            mf.showCaseStudy,
                                            mf.showSurvey,
                                            mf.showExpertSpeak,
                                            mf.showImpUpdates,
                                            mf.showArticles,
                                        ].map((item, index) => {
                                            return <Switch
                                                key={index + item.title}
                                                labelColor={theme.text}
                                                defaultChecked={isFormFieldTrue(item)}
                                                checked={isFormFieldTrue(item)}
                                                onChange={(e, value) => updateFormField(item, value)}>
                                                {item.title}
                                            </Switch>
                                        })}
                                    </div>)}
                            </Section>


                            {/*resources*/}
                            <Section
                                className={`px-3 py-2 h-100 app-section hover`}
                                titleClassName={'fs-md px-1'}
                                title={"Resources (Select to add to member area)"}
                                borderColor={theme.text10}
                                titleColor={theme.text}
                                titleAt={'start'}
                                overflow={'visible'}
                                roundedVariant={4}>
                                {animator.setAnimationType(AnimationType.SLIDE_RIGHT).setDuration(200).setEasing(EasingType.EASE_IN).renderChildren(
                                    <div>
                                        {[mf.showUploadDocument,
                                            mf.showCreateForum,
                                            mf.forumValidate,
                                        ].map((item, index) => {
                                            return <Switch
                                                key={index + item.title}
                                                labelColor={theme.text}
                                                // py={0}
                                                defaultChecked={isFormFieldTrue(item)}
                                                checked={isFormFieldTrue(item)}
                                                onChange={(e, value) => updateFormField(item, value)}>
                                                {item.title}
                                            </Switch>
                                        })}
                                    </div>)}
                            </Section>
                        </GridBox>
                    </ExpandableView>

                    {/*welcome & various section*/}
                    <ExpandableView className={'mt-3'} title={SECTIONS.welcomeAndVarious}
                                    retainInDOM={false}
                                    expanded={sectionsExpanded[SECTIONS.welcomeAndVarious]}
                                    onToggle={(exp) => handleSectionExpCollapse(SECTIONS.welcomeAndVarious, exp)}>
                        {/*welcome-section*/}
                        <Section
                            className={`px-3 py-2 mt-3 h-auto app-section hover`}
                            titleClassName={'fs-md px-1'}
                            title={"Welcome Message"}
                            borderColor={theme.text10}
                            titleColor={theme.text}
                            titleAt={'start'}
                            roundedVariant={4}>
                            {animator.setAnimationType(AnimationType.SLIDE_RIGHT).setDuration(200).setEasing(EasingType.EASE_IN).renderChildren(
                                <div>
                                    {/*welcomeImage*/}
                                    <Avatar
                                        wrapperClassName={'mt-2'}
                                        className={''}
                                        labelClassName={'w-100x pb-2 text-startxx'}
                                        justifyAt={'center'}
                                        alignAt={'start'}
                                        wrap={'wrap'}
                                        direction={'column'}
                                        label={mf.welcomeImage.title}
                                        labelColor={theme.text40}
                                        accept={'.jpg, .jpeg, .png'}
                                        editTooltip={`Edit (.jpg, .jpeg, .png)`}
                                        showEdit={true}
                                        showDelete={true}
                                        circular={false}
                                        showFullPreviewDialog={true}
                                        defAvatarImg={Constants.imgVector}
                                        editSize={'21px'}
                                        size={'80px'}
                                        width={'200px'}
                                        height={'150px'}
                                        maxSize={INPUT_FILE_MAX_SIZE}
                                        onChange={(e, file, path, name, ext) => {
                                            log('Avatar.welcomeImage.onChange.name:', name, 'ext:', ext);
                                            updateFormField(mf.welcomeImage, file);
                                            updateFormField(mf.welcomeImageExt, ext);
                                        }}
                                        onDeleteClick={() => {
                                            updateFormField(mf.welcomeImage, null);
                                            updateFormField(mf.welcomeImageExt, null);
                                        }}
                                        onInvalidFormat={(e, name) => {
                                            toast(`Invalid file format. File must be jpg, jpeg or png`, CssVariant.danger);
                                        }}
                                        onSizeExceeded={() => {
                                            toast(`Max size exceeded: ${INPUT_FILE_MAX_SIZE}`, CssVariant.danger);
                                        }}>
                                        {getFormField(mf.welcomeImage)}
                                    </Avatar>

                                    {/*welcomeMsg*/}
                                    <div className={'mt-3 mb-2'}>
                                        <AppTextEditor
                                            id={mf.welcomeMsg.column}
                                            label={mf.welcomeMsg.title}
                                            height={300}
                                            // initialValue={getFormField(mf.welcomeMsg)}
                                            value={getFormField(mf.welcomeMsg)}
                                            labelColor={theme.text40}
                                            onChange={(content) => {
                                                updateFormField(mf.welcomeMsg, content);
                                                panelLog('');
                                            }}
                                        />
                                    </div>
                                </div>)}
                        </Section>

                        <HorDiv className={'mt-4 mb-2'} variant={theme.text70}/>

                        {/*various*/}
                        {animator.setAnimationType(AnimationType.SLIDE_RIGHT).setDuration(200).setEasing(EasingType.EASE_IN).renderChildren(
                            <div className={'mt-3'}>
                                {/*impUpdate*/}
                                <AppTextEditor
                                    id={mf.impUpdate.column}
                                    label={mf.impUpdate.title}
                                    height={300}
                                    // initialValue={getFormField(mf.impUpdate)}
                                    value={getFormField(mf.impUpdate)}
                                    labelColor={theme.text40}
                                    onChange={(content) => {
                                        updateFormField(mf.impUpdate, content);
                                        panelLog('');
                                    }}
                                />

                                {/*legalNotice*/}
                                <ThemedInput
                                    wrapperClassName={'mt-3'}
                                    className={''}
                                    label={mf.legalNotice.title}
                                    placeholder={mf.legalNotice.title}
                                    id={mf.legalNotice.column}
                                    value={getFormField(mf.legalNotice)}
                                    msg={getFormFieldMsg(mf.legalNotice)}
                                    asTextArea={true}
                                    style={{minHeight: '100px', height: '200px', maxHeight: '1200px'}}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        updateFormField(mf.legalNotice, value);
                                        updateFormFieldMsg(mf.legalNotice, '');
                                        panelLog('');
                                    }}
                                />

                                {/*termsOfUse*/}
                                <ThemedInput
                                    wrapperClassName={''}
                                    className={''}
                                    label={mf.termsOfUse.title}
                                    placeholder={mf.termsOfUse.title}
                                    id={mf.termsOfUse.column}
                                    value={getFormField(mf.termsOfUse)}
                                    msg={getFormFieldMsg(mf.termsOfUse)}
                                    asTextArea={true}
                                    style={{minHeight: '100px', height: '200px', maxHeight: '1200px'}}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        updateFormField(mf.termsOfUse, value);
                                        updateFormFieldMsg(mf.termsOfUse, '');
                                        panelLog('');
                                    }}
                                />

                                {/*helpHeader*/}
                                <ThemedInput
                                    wrapperClassName={''}
                                    className={''}
                                    label={mf.helpHeader.title}
                                    placeholder={mf.helpHeader.title}
                                    id={mf.helpHeader.column}
                                    value={getFormField(mf.helpHeader)}
                                    msg={getFormFieldMsg(mf.helpHeader)}
                                    asTextArea={true}
                                    style={{minHeight: '50px', height: '100px', maxHeight: '250px'}}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        updateFormField(mf.helpHeader, value);
                                        updateFormFieldMsg(mf.helpHeader, '');
                                        panelLog('');
                                    }}
                                />

                                {/*helpBottom*/}
                                <ThemedInput
                                    wrapperClassName={''}
                                    className={''}
                                    label={mf.helpBottom.title}
                                    placeholder={mf.helpBottom.title}
                                    id={mf.helpBottom.column}
                                    value={getFormField(mf.helpBottom)}
                                    msg={getFormFieldMsg(mf.helpBottom)}
                                    asTextArea={true}
                                    style={{minHeight: '100px', height: '200px', maxHeight: '1200px'}}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        updateFormField(mf.helpBottom, value);
                                        updateFormFieldMsg(mf.helpBottom, '');
                                        panelLog('');
                                    }}
                                />
                            </div>
                        )}
                    </ExpandableView>
                </div>
            </FormPageRoot>
        </>
    )

    function handleSubmit() {
        const fun = 'handleSubmit:';
        log(fun, 'formData:', formData);
        if (UnderMaintenance) {
            toast(UnderMaintenanceMsg, CssVariant.warning);
            return false;
        }
        if (!isOnline) {
            toast(internetCheckingMsg, CssVariant.warning);
            return false;
        }

        try {
            let allFieldsChecked = checkRequiredFields();
            // allFieldsChecked = false;//for checking
            if (allFieldsChecked) {
                updateField(Fields.submitBtn_AsLoading, true);
                updateField(Fields.submitBtn_disabled, true);
                panelLog(null);

                const REQUEST_OPTIONS = {
                    updateOnly: isUpdateMode(),
                    recordId: getField(Fields.updateRecordId),
                    formData: formData,
                };
                sendAdminRequest({
                    reqUrl: AdminReqUrls.admin__company_addEditPage_submit_formData,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');

                        // updateField(Fields.submitBtn_disabled, false);//for testing only
                        if (success) {
                            toast(message, CssVariant.success);
                            if (showAs == ShowViewType.PAGE) {
                                redirectPage();
                            } else {
                                createTimeout(() => {
                                    clearPanelData();
                                }, 300);
                            }
                            if (onSuccess) onSuccess();
                        } else {
                            toast(message, CssVariant.danger);
                            updateField(Fields.submitBtn_disabled, false);
                        }
                        updateField(Fields.submitBtn_AsLoading, false);
                    }),
                    onError: ((error) => {
                        toast(Messages.saveError, CssVariant.danger);
                        updateField(Fields.submitBtn_AsLoading, false);
                        updateField(Fields.submitBtn_disabled, false);
                        logErr(fun, error);
                    }),
                });
            }
        } catch (error) {
            toast(Messages.saveError, CssVariant.danger);
            updateField(Fields.submitBtn_AsLoading, false);
            updateField(Fields.submitBtn_disabled, false);
            logErr(fun, error);
        }
    }

    async function fetchParentCompanies(checkBefore = true) {
        const fun = 'fetchParentCompanies:';
        if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isParentCompsFetched))) {
            updateField(Fields.showParentCompsLoading, true);
            updateField(Fields.isParentCompsFetched, true);
            updateField(Fields.parentComps, []);
            updateFormField(mf.parentCompanyId, null);
            updateFormField(mf.parentCompanyName, null);
            try {
                //send-request
                const REQUEST_OPTIONS = {};
                sendAdminRequest({
                    reqUrl: AdminReqUrls.admin__parentComp__mainPage_fetch_recordList,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        // log(fun, 'fetchedData:', fetchedData);
                        let comps = getJsonValue(fetchedData, 'data', []);
                        const success = checkNullArr(comps);
                        if (success) {
                            //format list
                            const mf_pc = AdminModuleFieldsData[AdminModules.ParentCompany];
                            comps = comps.map((item) => {
                                return {
                                    id: getJsonValue(item, mf_pc.recordId.title),
                                    text: getJsonValue(item, mf_pc.name.title),
                                };
                            }).filter(item => checkNullJson(item));
                            log(fun, 'fetchedData.comps:', comps);

                            updateField(Fields.parentComps, comps);
                            updateField(Fields.showParentCompsLoading, false);
                        } else {
                            toast("No parent companies found!", CssVariant.danger);
                            updateField(Fields.showParentCompsLoading, false);
                        }
                    }),
                    onError: ((error) => {
                        toast("Couldn't load parent-companies, please try again!", CssVariant.danger);
                        updateField(Fields.showParentCompsLoading, false);
                        logErr(fun, error);
                    }),
                });
            } catch (error) {
                toast("Couldn't load parent-companies, please try again!", CssVariant.danger);
                updateField(Fields.showParentCompsLoading, false);
                logErr(fun, error);
            }
        }
    }

    async function fetchEditModeData(recordId, checkBefore = true) {
        const fun = 'fetchEditModeData:';
        try {
            // log(fun, 'recordId:', recordId, 'isUpdateFormDataFetched:', isFieldTrue(Fields.isUpdateFormDataFetched));
            if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isUpdateFormDataFetched))) {
                updateField(Fields.isUpdateFormDataFetched, true);
                updateField(Fields.updateRecordId, recordId);
                if (checkNullStr(recordId)) {
                    updateField(Fields.isDataLoading, true);
                    updateField(Fields.dataLoadingMsg, "");

                    //send-request
                    const REQUEST_OPTIONS = {
                        recordId: recordId,
                    };
                    sendAdminRequest({
                        reqUrl: AdminReqUrls.admin__company_fetchEditPageRecord,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: ((fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const fetchedFormData = getJsonValue(fetchedData, 'data', {});
                            const message = getJsonValue(fetchedData, 'message');
                            const success = isJsonValueTrue(fetchedData, 'success');

                            updateField(Fields.isDataFound, success);
                            if (success) {
                                // toast(message, CssVariant.success);
                                setFormData(fetchedFormData);
                            } else {
                                toast(message, CssVariant.danger);
                                updateField(Fields.dataLoadingMsg, "Invalid record id!");
                            }
                            updateField(Fields.isDataLoading, false);
                        }),
                        onError: ((error) => {
                            logErr(fun, error);
                            updateField(Fields.dataLoadingMsg, Messages.fetchError);
                            updateField(Fields.isDataFound, false);
                            updateField(Fields.isDataLoading, false);
                        }),
                    });
                } else {
                    updateField(Fields.dataLoadingMsg, 'Record-id not found!');
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.isDataLoading, false);
                }
            }
        } catch (error) {
            logErr(fun, error);
            updateField(Fields.dataLoadingMsg, Messages.fetchError);
            updateField(Fields.isDataFound, false);
            updateField(Fields.isDataLoading, false);
        }
    }

    function redirectPage() {
        createTimeout(() => {
            panelLog(`Redirecting you to the '${moduleName}' page now...`);
            createTimeout(() => {
                // window.location.href = AdminModuleRouteUrls[moduleName];
                navigate(AdminModuleRouteUrls[moduleName]);
            }, 2500);
        }, 500);
    }

    function checkRequiredFields() {
        const fun = 'checkRequiredFields:';
        const requiredFields = Object.values(SectionRequiredFields).flat();
        // log(fun, "requiredFields:", requiredFields);

        let verified = false;
        let colField = {};
        let handleInvalids = true;
        for (const loopField of requiredFields) {
            const fieldValue = formData[loopField.column];
            if (!checkNullStr(fieldValue)) {
                colField = loopField;
                verified = false;
                break;
                // } else if (deepObjectComparison(loopField, mf.phone) || deepObjectComparison(loopField, mf.managerPhone) || deepObjectComparison(loopField, mf.contactPersonPhone1) || deepObjectComparison(loopField, mf.contactPersonPhone2) || deepObjectComparison(loopField, mf.contactPersonPhone3) || deepObjectComparison(loopField, mf.contactPersonMobile1) || deepObjectComparison(loopField, mf.contactPersonMobile2) || deepObjectComparison(loopField, mf.contactPersonMobile3)) {
            } else if (deepObjectComparison(loopField, mf.email) || deepObjectComparison(loopField, mf.managerEmail) || deepObjectComparison(loopField, mf.contactPersonEmail1) || deepObjectComparison(loopField, mf.contactPersonEmail2) || deepObjectComparison(loopField, mf.contactPersonEmail3)) {
                colField = loopField;
                let valid = Patterns.emailStandard.test(fieldValue);
                // log(fun, "email-validation-condition:", colField, 'fieldValue:', fieldValue, 'valid:', valid);
                if (!valid) {
                    verified = false;
                    handleInvalids = false;
                    const colTitle = getDefStr(loopField.titleAlt, loopField.title);
                    expandMatchingSectionByFieldName(colTitle);
                    toast(`'${colTitle}' is invalid!`, CssVariant.danger);
                    updateFormFieldMsg(loopField, 'Invalid email!');
                    focusIdField(loopField.column);
                    break;
                }
            } else {
                verified = true;
            }
        }
        if (!verified && handleInvalids) {
            const colTitle = getDefStr(colField.titleAlt, colField.title);
            expandMatchingSectionByFieldName(colTitle);
            // log(fun, "!verified.colField:", colField, 'idToFocus:', colField.column);
            updateFormFieldMsg(colField, 'Required field');
            toast(`'${colTitle}' cannot be empty!`, CssVariant.danger);
            focusIdField(colField.column);
        }
        return verified;
    }

    /**
     * Focus the expandable-section that contains the specified field name based on {@link SectionRequiredFields}.
     * @param {string} fieldTitle - The name of the field to search for.
     */
    function expandMatchingSectionByFieldName(fieldTitle) {
        const fun = 'expandMatchingSectionByFieldName:';
        // log(fun, 'fieldTitle:', fieldTitle, "sectionsExpanded:", sectionsExpanded);
        try {
            for (const [sectionName, fields] of Object.entries(SectionRequiredFields)) {
                handleSectionExpCollapse(sectionName, false);
                if (checkNullArr(fields) && fields.some(item => (item.title + '').includes(fieldTitle))) {
                    // log(fun, "sectionName:", sectionName);
                    // handleSectionExpCollapse(sectionName, true);
                    setSectionsExpanded({[sectionName]: true});
                    break;
                }
            }
        } catch (error) {
            logErr(fun, error);
        }
    }


    function focusIdField(id, onlyFocus = false) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
    }


    function clearPanelData() {
        setFormFieldsMsgs({});
        setFormData({});
        setFieldsData({});
    }

    function handleSectionExpCollapse(title, expanded) {
        setSectionsExpanded(prevState => ({...prevState, [title]: isBoolTrue(expanded)}));
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function updateFormField(clmField, value, direct = false) {
        setFormData(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormField(clmField, defValue, direct = false) {
        return getJsonValue(formData, direct ? clmField : clmField.column, defValue);
    }

    function isFormFieldTrue(clmField, direct = false) {
        return isBoolTrue(getFormField(clmField, null, direct), true, true);
    }

    function updateFormFieldMsg(clmField, value, direct = false) {
        setFormFieldsMsgs(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormFieldMsg(clmField, defValue, direct = false) {
        return getJsonValue(formFieldsMsgs, direct ? clmField : clmField.column, defValue);
    }

    function isUpdateMode() {
        return isBoolTrue(updateOnly);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        if (text) log(...[text]);
        ;
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        if (text) log(...[text]);
        ;
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

//======================Util Functions end=====================
});
export default Company__AddEditFormPage;


const ExpandableView = React.memo(({
                                       className = '',
                                       title,
                                       children,
                                       expanded = false,
                                       retainInDOM = true,
                                       onToggle,
                                   }) => {
    const TAG = "ExpandableView";
    const theme = useTheme();
    const [isOpen, setIsOpen] = useState(isBoolTrue(expanded));

    const animator = new FramerAnimator();

    useEffect(() => {
        // log('useEffect.expanded:', expanded);
        setIsOpen(isBoolTrue(expanded));
    }, [expanded]);

    const toggleOpen = () => {
        // log('toggleOpen.isOpen:', !isOpen);
        setIsOpen(!isOpen);
        if (onToggle) onToggle(!isOpen);
    };
    return (<div className={`border-1 rounded-4 ${className} ${isOpen ? `border-theme-resp-20` : `border-t`}`}>
        {/*header*/}
        <div className={`px-2x`} onClick={toggleOpen}>
            <div
                className={`text-theme-resp text-wrap fw-semi-bold cursor-pointer px-2 py-1 d-flex jc-between al-center fd-row flex-nowrap transition position-relative ${isOpen ? `highlight-dark-light highlight-dark-high-hover highlight-dark-high-active rounded-top-3` : `bg-dark-05 highlight-dark-light-hover highlight-dark-active rounded-3`}`}
            >
                <div className={'text-wrap'}>{title}</div>

                <ThemedIconButton
                    className={'mx-2 p-2'}
                    icon={`${isOpen ? IconClass.angleUp : IconClass.angleDown} exp-icon`}
                    tooltip={isOpen ? 'Collapse' : 'Expand'}
                    circular={true}
                    borderWidth={0}
                    outlined={true}
                    color={theme.text70}
                    hoverColor={theme.textDark}
                    hoverBgColor={theme.text20}
                    rippleColor={theme.text30}
                    size={'24px'}
                    iconSize={FsVarVariant.LG}
                    onClick={toggleOpen}
                />
            </div>
        </div>

        {/*children*/}
        {isBoolTrue(retainInDOM)
            ? animator.setAnimationType(AnimationType.SLIDE_UP).setDelay(150).setDuration(300).render(
                <div className={`px-3 py-1`}
                     style={{
                         display: isOpen ? 'block' : 'none',
                     }}>
                    {children}
                </div>)
            : (isOpen) && animator.setAnimationType(AnimationType.SLIDE_UP).setDelay(150).setDuration(300).render(
            <div className={`px-3 py-1`}>
                {children}
            </div>)
        }
    </div>)

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
});
